/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationTemplateTypeEnum } from './NotificationTemplateTypeEnum';
import {
    NotificationTemplateTypeEnumFromJSON,
    NotificationTemplateTypeEnumFromJSONTyped,
    NotificationTemplateTypeEnumToJSON,
    NotificationTemplateTypeEnumToJSONTyped,
} from './NotificationTemplateTypeEnum';
import type { NotificationLanguageIsoCodeEnum } from './NotificationLanguageIsoCodeEnum';
import {
    NotificationLanguageIsoCodeEnumFromJSON,
    NotificationLanguageIsoCodeEnumFromJSONTyped,
    NotificationLanguageIsoCodeEnumToJSON,
    NotificationLanguageIsoCodeEnumToJSONTyped,
} from './NotificationLanguageIsoCodeEnum';

/**
 * Notification template response
 * @export
 * @interface NotificationTemplateResponse
 */
export interface NotificationTemplateResponse {
    /**
     * UUID of a notification template
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    uuid: string;
    /**
     * 
     * @type {NotificationTemplateTypeEnum}
     * @memberof NotificationTemplateResponse
     */
    label: NotificationTemplateTypeEnum;
    /**
     * Content of a notification template
     * @type {string}
     * @memberof NotificationTemplateResponse
     */
    content: string;
    /**
     * 
     * @type {NotificationLanguageIsoCodeEnum}
     * @memberof NotificationTemplateResponse
     */
    language: NotificationLanguageIsoCodeEnum;
}



/**
 * Check if a given object implements the NotificationTemplateResponse interface.
 */
export function instanceOfNotificationTemplateResponse(value: object): value is NotificationTemplateResponse {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function NotificationTemplateResponseFromJSON(json: any): NotificationTemplateResponse {
    return NotificationTemplateResponseFromJSONTyped(json, false);
}

export function NotificationTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'label': NotificationTemplateTypeEnumFromJSON(json['label']),
        'content': json['content'],
        'language': NotificationLanguageIsoCodeEnumFromJSON(json['language']),
    };
}

export function NotificationTemplateResponseToJSON(json: any): NotificationTemplateResponse {
    return NotificationTemplateResponseToJSONTyped(json, false);
}

export function NotificationTemplateResponseToJSONTyped(value?: NotificationTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'label': NotificationTemplateTypeEnumToJSON(value['label']),
        'content': value['content'],
        'language': NotificationLanguageIsoCodeEnumToJSON(value['language']),
    };
}

